import { useMutation, gql } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { sessionsClient } from '../../../../utils/apollo/api'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'

const MUTATION = gql`
  mutation ChangePassword($token: String, $password: String) {
    changePassword(token: $token, password: $password)
  }
`

const useCreatePassword = form => {
  const { t } = useTranslation('session')
  const [request, state] = useMutation(MUTATION, { client: sessionsClient })
  const navigate = useNavigation()
  const notify = useNotification()

  const handleRequest = async e => {
    e.preventDefault()
    if (form.newPassword !== form.confirmPassword) return false
    if (!form.newPassword || !form.confirmPassword) return false

    return request({
      variables: {
        token: form?.token,
        password: form?.newPassword
      }
    })
      .then(resp => {
        if (!resp.errors) {
          const title = encodeURIComponent(t('newPasswordForm.passwordSetSuccess'))
          const description = encodeURIComponent(t('newPasswordForm.passwordSetDescription'))
          navigate(`/public/message?title=${title}&description=${description}`)
        } else {
          const title = encodeURIComponent(t('newPasswordForm.linkNoLongerValid'))
          const description = encodeURIComponent(t('newPasswordForm.requestNewPasswordChange'))
          navigate(`/public/message?title=${title}&description=${description}&type=error`)
        }
      })
      .catch(err =>
        notify.error({
          title: t('newPasswordForm.passwordNotUpdated'),
          message: `${t('newPasswordForm.passwordNotUpdated')}: ${err[0]?.message}`
        })
      )
  }

  return [handleRequest, state]
}

export default useCreatePassword
